import * as React from "react";
type Props = {
  className?: string,
};
function SvgSlider({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-slider"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5 13.5C15.5252 13.5 16.4063 14.1171 16.7921 15.0002L21 15V17L16.7916 17.0008C16.4056 17.8833 15.5248 18.5 14.5 18.5C13.4752 18.5 12.5944 17.8833 12.2084 17.0008L3 17V15L12.2079 15.0002C12.5937 14.1171 13.4748 13.5 14.5 13.5ZM9.5 5.5C10.5252 5.5 11.4063 6.11713 11.7921 7.00017L21 7V9L11.7916 9.00083C11.4056 9.88334 10.5248 10.5 9.5 10.5C8.47516 10.5 7.59435 9.88334 7.20838 9.00083L3 9V7L7.20795 7.00017C7.59368 6.11713 8.47477 5.5 9.5 5.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgSlider;
